module.exports = __webpack_public_path__ + "static/media/main-adbtn.73670a81.svg";